module.exports = __webpack_public_path__ + "static/media/cfCard.9d685e7c.png";